import { useCallback, useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfter = ({ before, after, alt = "", testId, start = 50, className = "", labels = ["Before", "After"], imgClass = "object-cover", afterLayer = null }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(start);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  }, []);

  return (
    <div
      ref={ref}
      data-testid={testId}
      className={`overflow-hidden select-none cursor-ew-resize ${className}`}
      style={{ touchAction: "pan-y" }}
      onPointerDown={(e) => {
        dragging.current = true;
        e.currentTarget.setPointerCapture?.(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => dragging.current && update(e.clientX)}
      onPointerUp={() => (dragging.current = false)}
      onPointerCancel={() => (dragging.current = false)}
    >
      {afterLayer || <img src={after} alt={`${alt} after`} className={`absolute inset-0 h-full w-full ${imgClass}`} draggable={false} decoding="async" />}
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={`${alt} before`} className={`absolute inset-0 h-full w-full ${imgClass}`} draggable={false} decoding="async" />
      </div>
      <span className="absolute top-3 left-3 pill-label">{labels[0]}</span>
      <span className="absolute top-3 right-3 pill-label !bg-white !text-[#050505]">{labels[1]}</span>
      <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -translate-x-1/2 w-[2px] bg-white shadow-[0_0_18px_4px_rgba(170,178,190,0.85)]" />
        <div className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-white text-[#050505] grid place-items-center shadow-[0_0_30px_rgba(170,178,190,0.9)]">
          <MoveHorizontal className="h-5 w-5" />
        </div>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Compare before and after"
        data-testid={testId ? `${testId}-range` : undefined}
        className="absolute inset-0 w-full h-full opacity-0 pointer-events-none"
      />
    </div>
  );
};
